import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { BellScheduleRequestModel } from "./BellScheduleRequestModel";

@Injectable()
export class DataService_BellScheduleSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadBellSchedule(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadBellSchedule?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadPeriods(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadPeriods?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddBellSchedule(parms: BellScheduleRequestModel) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/BellScheduleInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EditBellSchedule(parms: BellScheduleRequestModel) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/BellScheduleUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadBellScheduleDetails(BellScheduleID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadBellScheduleDetails?BellScheduleID=" + BellScheduleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BellScheduleToggle(BellScheduleID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/BellScheduleToggle?BellScheduleID=" + BellScheduleID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
